import { useEffect } from "react";

import i18n from "../../../../i18n";
import {
    setCenterPatientTerm,
    setPatientTerm,
    setProfessionalTerm,
} from "../../../../shared/i18n/patientTerm";
import { useTherapist } from "../../../../context/useTherapist";
import { useCenter } from "../../../center";

/**
 * Applies a training centre's vocabulary to the whole application.
 *
 * A training centre has trainers and students, not therapists and patients.
 * That is the only difference between the two verticals, and it is a matter of
 * words: nothing behaves differently, so nothing is branched — the same
 * post-processor that already swaps a therapist's chosen term does this one.
 *
 * The centre wins over the therapist's own preference. Somebody who set
 * "client" and then joined a training centre is teaching students now, and
 * calling them clients would be wrong rather than merely unfamiliar.
 */
export default function CenterVocabulary() {
    const { center } = useCenter();
    const { therapist } = useTherapist();
    const isTraining = center?.type === "training";

    useEffect(() => {
        setPatientTerm(therapist?.patient_term ?? null);
        // Kept apart from the therapist's own choice, so whichever of the two
        // effects runs last cannot undo the centre's words.
        setCenterPatientTerm(isTraining ? "student" : null);
        setProfessionalTerm(isTraining ? "trainer" : "therapist");
        // Re-render everything already translated with the previous words.
        i18n.changeLanguage(i18n.language);
    }, [isTraining, therapist?.patient_term]);

    return null;
}
